import {
    getInvoiceProviderLoading,
    getInvoiceProviderSuccess,
    getInvoiceProviderReject,
    getInvoiceProviderRequest
} from "../../actions/invoiceProvider/getAll";

export const getInvoiceProvider = (formData) => async (dispatch, getState) => {
    dispatch(getInvoiceProviderLoading());
    try {
        const { data } = await getInvoiceProviderRequest(formData, getState);
        dispatch(getInvoiceProviderSuccess(data))
    } catch (error) {
        dispatch(getInvoiceProviderReject(error))
    }
    return Promise.resolve();
};